// FETCH ALL STYLE
export const FETCH_STYLE_MASTER_BASIC_REQUEST = 'FETCH_STYLE_MASTER_BASIC_REQUEST';
export const FETCH_STYLE_MASTER_BASIC_SUCCESS = 'FETCH_STYLE_MASTER_BASIC_SUCCESS';
export const FETCH_STYLE_MASTER_BASIC_FAILURE = 'FETCH_STYLE_MASTER_BASIC_FAILURE';

// FETCH ALL STYLE
export const FETCH_STYLE_MASTER_BASIC_WITH_SKU_REQUEST = 'FETCH_STYLE_MASTER_BASIC_WITH_SKU_REQUEST';
export const FETCH_STYLE_MASTER_BASIC_WITH_SKU_SUCCESS = 'FETCH_STYLE_MASTER_BASIC_WITH_SKU_SUCCESS';
export const FETCH_STYLE_MASTER_BASIC_WITH_SKU_FAILURE = 'FETCH_STYLE_MASTER_BASIC_WITH_SKU_FAILURE';

// CREATE STYLE
export const CREATE_STYLE_MASTER_BASIC_REQUEST = 'CREATE_STYLE_MASTER_BASIC_REQUEST';
export const CREATE_STYLE_MASTER_BASIC_SUCCESS = 'CREATE_STYLE_MASTER_BASIC_SUCCESS';
export const CREATE_STYLE_MASTER_BASIC_FAILURE = 'CREATE_STYLE_MASTER_BASIC_FAILURE';

// UPDATE STYLE
export const UPDATE_STYLE_MASTER_BASIC_REQUEST = 'UPDATE_STYLE_MASTER_BASIC_REQUEST';
export const UPDATE_STYLE_MASTER_BASIC_SUCCESS = 'UPDATE_STYLE_MASTER_BASIC_SUCCESS';
export const UPDATE_STYLE_MASTER_BASIC_FAILURE = 'UPDATE_STYLE_MASTER_BASIC_FAILURE';

// FETCH SINGLE STATE OF STYLE
export const FETCH_SINGLE_STYLE_MASTER_BASIC_REQUEST = 'FETCH_SINGLE_STYLE_MASTER_BASIC_REQUEST';
export const FETCH_SINGLE_STYLE_MASTER_BASIC_SUCCESS = 'FETCH_SINGLE_STYLE_MASTER_BASIC_SUCCESS';
export const FETCH_SINGLE_STYLE_MASTER_BASIC_FAILURE = 'FETCH_SINGLE_STYLE_MASTER_BASIC_FAILURE';

// DELETE STYLE
export const DELETE_STYLE_MASTER_BASIC_REQUEST = 'DELETE_STYLE_MASTER_BASIC_REQUEST';
export const DELETE_STYLE_MASTER_BASIC_SUCCESS = 'DELETE_STYLE_MASTER_BASIC_SUCCESS';
export const DELETE_STYLE_MASTER_BASIC_FAILURE = 'DELETE_STYLE_MASTER_BASIC_FAILURE';

export const RESET_STYLE_MASTER_BASIC_INFO = 'RESET_STYLE_MASTER_BASIC_INFO';

export const CREATE_STYLE_MASTER_BASIC_FORM = 'CREATE_STYLE_MASTER_BASIC_FORM';

export const UPDATE_STYLE_MASTER_BASIC_FORM = 'UPDATE_STYLE_MASTER_BASIC_FORM';

// NAVIGATE TO STYLE SKU_MASTER COMPONENT
export const NAVIGATE_STYLE_SKU_MASTER = 'NAVIGATE_STYLE_SKU_MASTER';

// NAVIGATE TO STYLE COMPONENT
export const NAVIGATE_STYLE_MASTER_BASIC = 'NAVIGATE_STYLE_MASTER_BASIC';
